/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Part_Return_DefectiveInputs */

const en_ticket_part_return_defective = /** @type {(inputs: Ticket_Part_Return_DefectiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return defective`)
};

const ja_ticket_part_return_defective = /** @type {(inputs: Ticket_Part_Return_DefectiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不良品を返却`)
};

const fr_ticket_part_return_defective = /** @type {(inputs: Ticket_Part_Return_DefectiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour défectueux`)
};

const de_ticket_part_return_defective = /** @type {(inputs: Ticket_Part_Return_DefectiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defekt zurücksenden`)
};

/**
* | output |
* | --- |
* | "Return defective" |
*
* @param {Ticket_Part_Return_DefectiveInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_part_return_defective = /** @type {((inputs?: Ticket_Part_Return_DefectiveInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Part_Return_DefectiveInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_part_return_defective(inputs)
	if (locale === "ja") return ja_ticket_part_return_defective(inputs)
	if (locale === "fr") return fr_ticket_part_return_defective(inputs)
	return de_ticket_part_return_defective(inputs)
});